import { call, put, takeLatest } from "redux-saga/effects";
import {
  addFloorFailure,
  addFloorSuccess,
  deleteFloorFailure,
  deleteFloorSuccess,
  fetchallFloorsFailure,
  fetchAllFloorsFailure,
  fetchallFloorsSuccess,
  fetchAllFloorsSuccess,
  fetchFloorFailure,
  fetchFloorsFailure,
  fetchFloorsSuccess,
  fetchFloorSuccess,
  updateFloorFailure,
  updateFloorSuccess,
  fetchCommonFloorsSuccess,
  fetchCommonFloorsFailure,
} from "./floorAction";
import {
  addFloorEffect,
  deleteFloorEffect,
  editFloorEffect,
  listAllFloor,
  listAllFloorEffect,
  listFloorEffect,
  viewFloorEffect,
  listCommonFloorEffect,
} from "./floorEffect";
import {
  ADD_FLOOR_REQUEST,
  DELETE_FLOOR_REQUEST,
  FETCH_FLOOR_REQUEST,
  FETCH_LIST_All_FLOOR_REQUEST,
  FETCH_LIST_AllS_FLOOR_REQUEST,
  FETCH_LIST_FLOOR_REQUEST,
  UPDATE_FLOOR_REQUEST,
  FETCH_COMMON_FLOOR_REQUEST,
} from "./floorType";

function* fetchFloorsSaga(action) {
  const { blockId, wardId } = action.payload;

  try {
    const response = yield call(listFloorEffect, { blockId, wardId });
    yield put(fetchFloorsSuccess(response.data));
  } catch (error) {
    yield put(fetchFloorsFailure(error.message));
  }
}

function* fetchAllFloors(action) {
  try {
    const response = yield call(listAllFloor, action.payload);
    yield put(fetchallFloorsSuccess(response.data));
  } catch (error) {
    yield put(fetchallFloorsFailure(error.message));
  }
}
function* fetchAllFloorsSaga(action) {
  try {
    const response = yield call(listAllFloorEffect, action);
    yield put(fetchAllFloorsSuccess(response.data));
  } catch (error) {
    yield put(fetchAllFloorsFailure(error.message));
  }
}
function* fetchFloorSaga(action) {
  try {
    const response = yield call(viewFloorEffect, action.payload.floorId);
    yield put(fetchFloorSuccess(response.data));
  } catch (error) {
    yield put(fetchFloorFailure(error.message));
  }
}

function* addFloorSaga(action) {
  try {
    const response = yield call(addFloorEffect, action.payload.floorData);
    yield put(addFloorSuccess(response.data));
  } catch (error) {
    const backendMessage =
      error.response?.data?.message || error.message || "Login failed";
    yield put(addFloorFailure(backendMessage));
  }
}

function* updateFloorSaga(action) {
  try {
    const response = yield call(
      editFloorEffect,
      action.payload.floorId,
      action.payload.floorData
    );
    yield put(updateFloorSuccess(response.data));
  } catch (error) {
    const backendMessage =
      error.response?.data?.message || error.message || "Login failed";
    yield put(updateFloorFailure(backendMessage));
  }
}

function* deleteFloorSaga(action) {
  try {
    yield call(deleteFloorEffect, action.payload.floorId);
    yield put(deleteFloorSuccess(action.payload.floorId));
  } catch (error) {
    yield put(deleteFloorFailure(error.message));
  }
}

function* fetchCommonFloorsSaga() {
  try {
    const response = yield call(listCommonFloorEffect);
    yield put(fetchCommonFloorsSuccess(response.data));
  } catch (error) {
    yield put(fetchCommonFloorsFailure(error.message));
  }
}

export function* floorSagas() {
  yield takeLatest(FETCH_LIST_FLOOR_REQUEST, fetchFloorsSaga);
  yield takeLatest(FETCH_FLOOR_REQUEST, fetchFloorSaga);
  yield takeLatest(ADD_FLOOR_REQUEST, addFloorSaga);
  yield takeLatest(UPDATE_FLOOR_REQUEST, updateFloorSaga);
  yield takeLatest(DELETE_FLOOR_REQUEST, deleteFloorSaga);
  yield takeLatest(FETCH_LIST_All_FLOOR_REQUEST, fetchAllFloorsSaga);
  yield takeLatest(FETCH_LIST_AllS_FLOOR_REQUEST, fetchAllFloors);
  yield takeLatest(FETCH_COMMON_FLOOR_REQUEST, fetchCommonFloorsSaga);
}
